import React, { useState, useEffect } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import { adexHistory } from 'lib/api/adex';

// import BasicTable from 'components/molecules/MbBasicTable';
// import MbSelectbox from 'components/molecules/MbSelectbox';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
// import TableCell from '@material-ui/core/TableCell';
// import TableRow from '@material-ui/core/TableRow';

// import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';

// const useStyles = makeStyles(theme => ({
//   subContent: {
//     color: theme.palette.primary.contrastText,
//   },
// }));

const MediaHistroy = ({ location }) => {
  // const { t } = useTranslation();
  // const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);

  const { mediaScriptNo } = queryString.parse(location.search);
  useEffect(() => {
    const getData = () => {
      setLoading(true);
      adexHistory({
        mediaScriptNo: mediaScriptNo,
      })
        .then((response) => {
          //   const { data } = response.data;
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getData();
    // eslint-disable-next-line
  }, []);

  return <>{loading}</>;
};
export default withRouter(MediaHistroy);
